/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { SchedulePlanSessionFragmentDoc, ScheduleProjectFragmentDoc, ScheduleWhoFragmentDoc } from '../schedule/Fragments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { PlanningMapProjectFragmentDoc } from './PlanningMap.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditProjectPlanSessionsModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditProjectPlanSessionsModalQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, planSessions: Array<{ __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } }> } | null } };

export type EditProjectPlanSessionsModal_ProjectQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditProjectPlanSessionsModal_ProjectQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, ticket: boolean, title: string, owningSystemOrganisationId: string, viewerPermissions: Array<Types.PermissionName>, earliestPlanSessionDate?: any | null, latestPlanSessionDate?: any | null, earliestStart?: any | null, deadline?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, number: string, createdAt?: any | null, categories: Array<string>, type: Types.ProjectType, leadId?: number | null, urgent: boolean, planned: boolean, building?: { __typename: 'Building', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }>, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, fullname: string }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> }>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, id: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, budget?: { __typename: 'Money', currency: string, amount: number } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, crmCompany: { __typename: 'CrmCompany', id: string } } }> } | null } };

export type EditProjectPlanSessionsModal_ProjectFragment = { __typename: 'Project', id: string, ticket: boolean, title: string, owningSystemOrganisationId: string, viewerPermissions: Array<Types.PermissionName>, earliestPlanSessionDate?: any | null, latestPlanSessionDate?: any | null, earliestStart?: any | null, deadline?: any | null, building?: { __typename: 'Building', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }>, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, fullname: string }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> }>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null };

export type EditProjectPlanSessionsModal_OrganisationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EditProjectPlanSessionsModal_OrganisationQuery = { organisationDefaults: { __typename: 'OrganisationDefaults', id: string, defaultStartWorkDay?: string | null, defaultEndWorkDay?: string | null, defaultProjectDuration: number, defaultTicketDuration: number } };

export type EditProjectPlanSessionsModal_UpdateMutationVariables = Types.Exact<{
  input: Types.UpdatePlanSessionsInput;
}>;


export type EditProjectPlanSessionsModal_UpdateMutation = { updatePlanSessions: { __typename: 'UpdatePlanSessionsResult', ok: boolean } };

export const EditProjectPlanSessionsModal_ProjectFragmentDoc = gql`
    fragment EditProjectPlanSessionsModal_Project on Project {
  id
  ticket
  title
  owningSystemOrganisationId
  viewerPermissions
  building {
    id
    title
    buildingAddress {
      ...AddressDetails__Address
    }
  }
  roles {
    id
    internalName
  }
  internalStakeholders {
    id
    user {
      id
      fullname
    }
    roles {
      id
      internalName
    }
  }
  earliestPlanSessionDate
  latestPlanSessionDate
  ...ScheduleProject
}
    ${AddressDetails__AddressFragmentDoc}
${ScheduleProjectFragmentDoc}`;
export const EditProjectPlanSessionsModalDocument = gql`
    query EditProjectPlanSessionsModal($id: ID!) {
  project(id: $id) {
    ... on ProjectResult {
      project {
        id
        planSessions {
          id
          ...SchedulePlanSession
        }
      }
    }
  }
}
    ${SchedulePlanSessionFragmentDoc}`;

/**
 * __useEditProjectPlanSessionsModalQuery__
 *
 * To run a query within a React component, call `useEditProjectPlanSessionsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPlanSessionsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectPlanSessionsModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditProjectPlanSessionsModalQuery(baseOptions: Apollo.QueryHookOptions<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables> & ({ variables: EditProjectPlanSessionsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>(EditProjectPlanSessionsModalDocument, options);
      }
export function useEditProjectPlanSessionsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>(EditProjectPlanSessionsModalDocument, options);
        }
export function useEditProjectPlanSessionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>(EditProjectPlanSessionsModalDocument, options);
        }
export type EditProjectPlanSessionsModalQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModalQuery>;
export type EditProjectPlanSessionsModalLazyQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModalLazyQuery>;
export type EditProjectPlanSessionsModalSuspenseQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModalSuspenseQuery>;
export type EditProjectPlanSessionsModalQueryResult = Apollo.QueryResult<EditProjectPlanSessionsModalQuery, EditProjectPlanSessionsModalQueryVariables>;
export const EditProjectPlanSessionsModal_ProjectDocument = gql`
    query EditProjectPlanSessionsModal_Project($id: ID!) {
  project(id: $id) {
    ... on ProjectResult {
      project {
        id
        ...EditProjectPlanSessionsModal_Project
        ...PlanningMapProject
      }
    }
  }
}
    ${EditProjectPlanSessionsModal_ProjectFragmentDoc}
${PlanningMapProjectFragmentDoc}`;

/**
 * __useEditProjectPlanSessionsModal_ProjectQuery__
 *
 * To run a query within a React component, call `useEditProjectPlanSessionsModal_ProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPlanSessionsModal_ProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectPlanSessionsModal_ProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditProjectPlanSessionsModal_ProjectQuery(baseOptions: Apollo.QueryHookOptions<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables> & ({ variables: EditProjectPlanSessionsModal_ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>(EditProjectPlanSessionsModal_ProjectDocument, options);
      }
export function useEditProjectPlanSessionsModal_ProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>(EditProjectPlanSessionsModal_ProjectDocument, options);
        }
export function useEditProjectPlanSessionsModal_ProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>(EditProjectPlanSessionsModal_ProjectDocument, options);
        }
export type EditProjectPlanSessionsModal_ProjectQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_ProjectQuery>;
export type EditProjectPlanSessionsModal_ProjectLazyQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_ProjectLazyQuery>;
export type EditProjectPlanSessionsModal_ProjectSuspenseQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_ProjectSuspenseQuery>;
export type EditProjectPlanSessionsModal_ProjectQueryResult = Apollo.QueryResult<EditProjectPlanSessionsModal_ProjectQuery, EditProjectPlanSessionsModal_ProjectQueryVariables>;
export const EditProjectPlanSessionsModal_OrganisationDocument = gql`
    query EditProjectPlanSessionsModal_Organisation {
  organisationDefaults {
    ... on OrganisationDefaults {
      id
      defaultStartWorkDay
      defaultEndWorkDay
      defaultProjectDuration
      defaultTicketDuration
    }
  }
}
    `;

/**
 * __useEditProjectPlanSessionsModal_OrganisationQuery__
 *
 * To run a query within a React component, call `useEditProjectPlanSessionsModal_OrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPlanSessionsModal_OrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectPlanSessionsModal_OrganisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditProjectPlanSessionsModal_OrganisationQuery(baseOptions?: Apollo.QueryHookOptions<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>(EditProjectPlanSessionsModal_OrganisationDocument, options);
      }
export function useEditProjectPlanSessionsModal_OrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>(EditProjectPlanSessionsModal_OrganisationDocument, options);
        }
export function useEditProjectPlanSessionsModal_OrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>(EditProjectPlanSessionsModal_OrganisationDocument, options);
        }
export type EditProjectPlanSessionsModal_OrganisationQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_OrganisationQuery>;
export type EditProjectPlanSessionsModal_OrganisationLazyQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_OrganisationLazyQuery>;
export type EditProjectPlanSessionsModal_OrganisationSuspenseQueryHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_OrganisationSuspenseQuery>;
export type EditProjectPlanSessionsModal_OrganisationQueryResult = Apollo.QueryResult<EditProjectPlanSessionsModal_OrganisationQuery, EditProjectPlanSessionsModal_OrganisationQueryVariables>;
export const EditProjectPlanSessionsModal_UpdateDocument = gql`
    mutation EditProjectPlanSessionsModal_Update($input: UpdatePlanSessionsInput!) {
  updatePlanSessions(input: $input) {
    ok
  }
}
    `;
export type EditProjectPlanSessionsModal_UpdateMutationFn = Apollo.MutationFunction<EditProjectPlanSessionsModal_UpdateMutation, EditProjectPlanSessionsModal_UpdateMutationVariables>;

/**
 * __useEditProjectPlanSessionsModal_UpdateMutation__
 *
 * To run a mutation, you first call `useEditProjectPlanSessionsModal_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectPlanSessionsModal_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectPlanSessionsModalUpdateMutation, { data, loading, error }] = useEditProjectPlanSessionsModal_UpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectPlanSessionsModal_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectPlanSessionsModal_UpdateMutation, EditProjectPlanSessionsModal_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectPlanSessionsModal_UpdateMutation, EditProjectPlanSessionsModal_UpdateMutationVariables>(EditProjectPlanSessionsModal_UpdateDocument, options);
      }
export type EditProjectPlanSessionsModal_UpdateMutationHookResult = ReturnType<typeof useEditProjectPlanSessionsModal_UpdateMutation>;
export type EditProjectPlanSessionsModal_UpdateMutationResult = Apollo.MutationResult<EditProjectPlanSessionsModal_UpdateMutation>;
export type EditProjectPlanSessionsModal_UpdateMutationOptions = Apollo.BaseMutationOptions<EditProjectPlanSessionsModal_UpdateMutation, EditProjectPlanSessionsModal_UpdateMutationVariables>;